// <head> metadata for PartnersPage (https://www.dbos.dev/partners).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'Durable Workflow Orchestration Partners & Integrations | DBOS',
    },
    {
      name: 'description',
      content:
        'DBOS partners with AI and cloud infrastructure providers and implementation firms to help mutual customers build and run durable workflows.',
    },
    {
      property: 'og:title',
      content: 'Durable Workflow Orchestration Partners & Integrations | DBOS',
    },
    {
      property: 'og:description',
      content:
        'DBOS partners with AI and cloud infrastructure providers and implementation firms to help mutual customers build and run durable workflows.',
    },
    {
      property: 'og:image',
      content: 'https://www.dbos.dev/assets/images/dbos-og-durable-workflows-postgres.jpg',
    },
    {
      name: 'twitter:title',
      content: 'Durable Workflow Orchestration Partners & Integrations | DBOS',
    },
    {
      name: 'twitter:description',
      content:
        'DBOS partners with AI and cloud infrastructure providers and implementation firms to help mutual customers build and run durable workflows.',
    },
    {
      name: 'twitter:image',
      content: 'https://www.dbos.dev/assets/images/dbos-og-durable-workflows-postgres.jpg',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/partners',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
